/* SVADEZI — reveal threshold fix  (loads after theme.js)

   BUG: theme.js observes .reveal with { threshold: 0.12 }, i.e. 12% of the
   element must intersect before it fades in. That works for the small blocks
   the brand app wraps individually, but the Shopify PDP wraps its ENTIRE right
   column in a single .pdp-buy.reveal that measures ~3042px tall. 12% of that
   is ~365px, and at scroll 0 only ~82px of it is on screen — so the title,
   price, variant pills, Add to bag and accordions all stayed at opacity 0
   until the shopper scrolled a long way down. The page read as blank.

   FIX: re-observe with threshold 0 so anything is revealed the moment its
   first pixel enters (keeping the app's -60px bottom margin for the same
   "rises as it scrolls in" feel). Elements already on screen reveal at once.
   theme.js's own observer still runs; whichever fires first wins, which is
   harmless because is-visible is idempotent.

   Also a safety net: never leave content permanently invisible. If anything is
   still hidden after load (no IO support, an observer that never fires), show
   it rather than hiding the shop. */
(function () {
  var SEL = '.reveal:not(.is-visible)';

  function showAll() {
    document.querySelectorAll(SEL).forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  if (!('IntersectionObserver' in window)) { showAll(); return; }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });

  function bind() {
    document.querySelectorAll(SEL).forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  // catch sections injected later (Shopify section rendering, theme editor)
  window.addEventListener('load', bind);

  // last resort: nothing should stay invisible for more than a few seconds
  window.setTimeout(showAll, 4000);
})();
